export default {
  // 功能扩展参数：支持表格上方 - 配置 查询条件
  queryGroupUrl: {
    type: String,
    default: '',
  },
  // 功能扩展参数：支持表格上方 - 配置 顶部搜索框【默认显示】
  showOfSearchInput: {
    type: Boolean,
    default: true,
  },
  formatterObj: {
    type: Object,
    default: null,
  },
  domTransfer: {
    type: String,
    default: '#routerView',
  },
  idPrefix: {
    type: String,
    default: 'selectOfModalTable',
  },
  buttonOfTableTop: {
    type: Boolean,
    default: false,
  },
  sideModalWidth: {
    type: [String, Number],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Boolean,
    default: false,
  },
  transfer: {
    type: Boolean,
    default: true,
  },
  value: {
    type: [Object, Array, String],
    //  default:()=>{  return {id:null,code:null,name:null}  }
  },

  requestMethod: {
    type: String,
    default: 'post',
  },
  // 请求参数,json格式或者对象
  requestParam: {
    type: [String, Object],
    default: null,
  },
  // 是否显示tag清除
  isShowClear: {
    type: Boolean,
    default: true,
  },
  sideAddKey: {
    type: String,
    default: 'id',
  },
  searchKey: {
    type: String,
    default: 'keyword',
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  tableColumnDef: {
    type: Array,
    default: () => {
      return [
        {
          prop: 'code',
          label: '编码',
        },
        {
          prop: 'name',
          label: '名称',
        },
      ]
    },
  },
  placeholder: {
    type: String,
    default: '关键字',
  },

  url: {
    type: String,
    default: '',
  },
  text: {
    type: String,
    default: '选择',
  },
  title: {
    type: String,
    default: '选择',
  },
  showModal: {
    type: Boolean,
    default: false,
  },
  // 是否显示选择值。2个场景：1。显示值场景：编辑页面，显示值，并可以点击选择。2.不显示值场景：菜单点击，侧滑选择值，提交后，直接出发后续动作。
  isShowValue: {
    type: Boolean,
    default: true,
  },
  clickRow: {
    type: Function,
  },
  field: {
    type: String,
    default: '',
  },
  isParameters: {
    type: Boolean,
    default: false,
  },
  tableRowMenuItem: {
    type: Array,
    default: () => {
      return [
        {
          icon: 'ivu-icon-icon-pg-operation',
          name: '编辑地址库信息',
          type: 'edit',
          style: '',
        },
        {
          icon: 'ivu-icon-icon-pg-operation',
          name: '删除',
          type: 'remove',
          style: 'error',
        },
      ]
    },
  },
  operateCellOfTableRow: {
    type: Boolean,
    default: false,
  },
  modalFormBodyBgc: {
    type: Boolean,
    default: false,
  },
  modalFormWidth: {
    type: [String, Number],
    default: '340',
  },
  urlSaveForModalForm: {
    type: String,
    default: '',
  },
  urlRemoveForRow: {
    type: String,
    default: '',
  },
  urlModalFormItemsDef: {
    type: String,
    default: '',
  },
  urlGetOfEditForModalForm: {
    type: String,
    default: '',
  },
  modalFromTitle: {
    type: String,
    default: '提示',
  },
  maskClosable: {
    type: Boolean,
    default: true,
  },
  showKey: {
    type: String,
    default: 'name',
  },
  selectPrams: {
    type: Object,
    default: () => {
      return {
        url: '',
        prams: {},
        pramsKey: null,
        pramsVal: null,
        methods: 'get',
        pramsType: 'string',
      }
    },
  },
  topToolTipInfo: {
    // 用于在顶部提示信息
    type: Object,
    default: () => {
      return {
        show: false,
        content: '',
      }
    },
  },
  // 线上客户订单->待确认->变更品规信息->选择预发货仓库 支持显示文本还有清空按钮
  showAbleClearText: {
    type: Boolean,
    default: false,
  },
  showInput: {
    // 用于显示成input
    type: Boolean,
    default: false,
  },
  // -----------------------tags-------------------------
  // 用于显示tags
  showTags: {
    type: Boolean,
    default: false,
  },
  showRecentTags: {
    type: Boolean,
    default: false,
  },
  // 自动关闭侧滑
  autoClosed: {
    type: Boolean,
    default: false,
  },
  pickUp: {
    type: Boolean,
  },
  // 显示加号得添加符
  iconSelection: {
    type: Boolean,
    default: true,
  },
  // 功能扩展参数：支持表格 - 配置 列定义url
  tableColumnDefUrl: {
    type: String,
    default: '',
  },
  tableColumnDefTag: {
    type: Object,
  },
  requestTagsObject: {
    type: Object,
    default: () => {
      return {
        url: '',
        params: {},
        methods: 'post',
      }
    },
  },
  openSelectedArr: {
    type: Boolean,
    default: true,
  },
  ifStopPropagation: {
    type: Boolean,
    default: false,
  },
  showKeySubFlagKey: {
    type: String,
    default: null,
  },
  store: {
    type: Object,
    default: null,
  },
  pageSizeOption: {
    type: Array,
    default: () => [10, 20, 30, 40],
  },
  pageSize: {
    type: Number,
    default: 10,
  },
  defaultKeyWord: {
    type: String,
    default: '',
  },
}
